export default __webpack_public_path__ + "static/media/portfolio-147.cda01d78.jpg";